import { GTIWebButton, Dialog, Typography, Grid, Box, Stack, Icon } from "@gti-controls-v2/web-core";
import useTranslation from "../../hooks/useTranslation";
import homePageStyles from "../../common/styles/HomePage";
import { titleIcons } from "../../common/constants/TitleIcons";
import { containsHTML } from "../../common/utilities";

export const GTIWebModal = ({
    open,
	title,
	description,
	icon,
	acceptButtonText,
	cancelButtonText,
	hideAceptButton,
	hideCancelButton,
	onAccept,
	onCancel,
	onClose,
	...props
}) => {

	const { t } = useTranslation();
	const styles = homePageStyles;

	const close = () => {
		if (onClose) {
			onClose();
		}
	};

	const accept = () => {
		if (onAccept) {
			onAccept();
		}

		close();
	};

	const cancel = () => {
		if (onCancel) {
			onCancel();
		}

		close();
	};

	return (
		<>
			<Dialog
				open={open}
				maxWidth="sm"
				fullWidth
			>
				<Box sx={styles.modal}>
                    <Grid container justify="flex-end">
                        <Grid item xs={12}>
                            <Box sx={styles.modalHeader}>
                                <Icon
                                    fontSize={"large"}
                                    sx={{
                                        color: icon?.color || titleIcons.info.color,
                                        marginRight: "16px",
                                    }}
                                >
                                    {icon?.src || titleIcons.info.src}
                                </Icon>
                                <Box sx={styles.modalHeaderText}>
                                    <Typography variant="h5" sx={styles.modalTitle}>
                                        {title || ""}
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>
                        {description && (
                            <Grid item xs={12} style={{ paddingTop: "8px", paddingBottom: "20px" }}>
                                <Box>
                                    {containsHTML(description) ? (
                                        <Typography
                                            className="content"
                                            dangerouslySetInnerHTML={{ __html: description }}>
                                        </Typography>
                                    ) : (
                                        <Typography>
                                            {description}
                                        </Typography>
                                    )}
                                </Box>
                            </Grid>
                        )}
                        <Grid item xs={12}>
                            <Box sx={styles.modalButtons}>
                                <Box sx={styles.spacer} />
                                <Box>
                                    <Stack width="100%" direction="row">
                                        {!hideAceptButton && <GTIWebButton
                                            id={"Button_Modal_Aceptar_id"}
                                            sx={styles.modalActionButton}
                                            iconPosition={"end"}
                                            text={acceptButtonText || t("sistema.acciones.aceptar")}
                                            width={"100%"}
                                            onClick={accept}
                                        />}
                                        {!hideCancelButton && <GTIWebButton
                                            id={"Button_Modal_Cancelar_id"}
                                            sx={styles.modalActionButton}
                                            iconPosition={"end"}
                                            text={cancelButtonText || t("sistema.acciones.cancelar")}
                                            width={"100%"}
                                            onClick={cancel}
                                        />}
                                    </Stack>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
			</Dialog>
		</>
	);
};